import { Membership } from '@com-delta-idp/mnx-sky-club-ui';
import { AEMErrorMessage } from '@com-delta-idp/mnx-skymiles-shared';
import { GenericAction, GenericLabel } from '@com-delta-omnichannel/aura';
import { AEMPurchaseContent, Options } from '../../models';

export const MembershipOptionsMocks: Options[] = [
  {
    type: {
      title: 'One-Year Executive Membership',
      subtitle: 'valid through',
      content: 'May 15, 2025'
    },
    currencies: [
      {
        value: '$1495',
        label: 'per year',
        selected: false
      },
      {
        value: '149500',
        label: 'miles per year',
        selected: false
      }
    ],
    membershipDetails: [
      {
        currencyCode: 'USD',
        denomination: 'currency',
        expirationDate: 'Oct 10, 2025',
        membershipDescription: 'EXECUTIVE MEMBERSHIP - MEDALLION MEMBERS',
        milesFlag: false,
        objectIndex: 3,
        planId: 'Yearly',
        shoppingValue: 1495,
        code: 'EX1495',
        contractTypeCode: 'E'
      },
      {
        currencyCode: '',
        denomination: 'miles',
        expirationDate: 'Oct 10, 2025',
        membershipDescription: 'EXECUTIVE MEMBERSHIP - MEDALLION MEMBERS',
        milesFlag: true,
        objectIndex: 4,
        planId: 'Yearly',
        shoppingValue: 149500,
        code: 'EX1YRM',
        contractTypeCode: 'E'
      }
    ]
  },
  {
    type: {
      title: 'One-Year Individual Membership',
      subtitle: 'valid through',
      content: 'May 15, 2025'
    },
    currencies: [
      {
        value: '$695',
        label: 'per year',
        selected: false
      },
      {
        value: '69500',
        label: 'miles per year',
        selected: false
      }
    ],
    membershipDetails: [
      {
        currencyCode: 'USD',
        denomination: 'currency',
        expirationDate: 'Oct 10, 2025',
        membershipDescription: 'INDIVIDUAL MEMBERSHIP - MEDALLION MBRS',
        milesFlag: false,
        objectIndex: 2,
        planId: 'Yearly',
        shoppingValue: 695,
        code: 'I695',
        contractTypeCode: 'I'
      },
      {
        currencyCode: '',
        denomination: 'miles',
        expirationDate: 'Oct 10, 2025',
        membershipDescription: 'INDIVIDUAL MEMBERSHIP - MEDALLION MBRS',
        milesFlag: true,
        objectIndex: 1,
        planId: 'Yearly',
        shoppingValue: 69500,
        code: 'I695M',
        contractTypeCode: 'I'
      }
    ]
  }
];

export const ActionMocks: GenericAction = {
  id: 'addToCart',
  label: 'ADD TO CART'
};

export const TotalMocks: GenericLabel = {
  title: 'Total : ',
  subtitle: '$0.00'
};

export const AEMPurchaseContentMocks: AEMPurchaseContent = {
  options: MembershipOptionsMocks,
  action: ActionMocks,
  total: TotalMocks
};

export const APIPurchaseErrorMessagesMocks: AEMErrorMessage = {
  action: {
    label: '',
    url: '',
    id: ''
  },
  component: 'skyClubError',
  errorId: [],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we’re currently unable to display this membership options. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};

export const membershipMocks: Membership = {
  value: '',
  selected: true,
  detail: {
    currencyCode: 'USD',
    denomination: 'currency',
    expirationDate: 'Oct 10, 2025',
    membershipDescription: 'INDIVIDUAL MEMBERSHIP - MEDALLION MBRS',
    milesFlag: true,
    objectIndex: 4,
    planId: 'Yearly',
    shoppingValue: 695,
    code: 'I695',
    contractTypeCode: 'I'
  }
};
